import React from "react";
import { Alert, Modal } from "react-bootstrap";
import DropZone from "react-dropzone";
import "./UploadZone.css";

export default class UploadZone extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      files: [],
      rejectFiles: [],
      showError: false,
      isIntervention: props.isIntervention || false
    };
  }

  handleClose = () => {
    this.setState({ showError: false, rejectFiles: [] });
  }

  onDrop = (acceptedFiles) => {
    let { files, isIntervention } = this.state;
    let rejectFiles = [];
    const maxSize = 50 * 1024 * 1024;
    const maxSizeFile = 8 * 1024 * 1024;
    let totalSize = 0;
    //for (let i = 0; i < acceptedFiles.length; i++) {
    for (let acceptedFile of acceptedFiles) {
      totalSize += acceptedFile.size;

      if (totalSize < maxSize && acceptedFile.size < maxSizeFile) {
        if (isIntervention) {
          if (files.length == 0 && acceptedFile.name.endsWith(".pdf")) {
            files.push(acceptedFile);
          } else {
            rejectFiles.push(acceptedFile);
          }
        } else {
          files.push(acceptedFile);
        }
      } else {
        rejectFiles.push(acceptedFile);
      }
    }
    const showError = rejectFiles.length > 0;
    this.props.setFiles(files);
    this.setState({ files, rejectFiles, showError });
  };

  removeImage = (idx) => {
    let { files } = this.state;
    const filesFiltered = files.filter(function (value, index, arr) {
      return index !== idx;
    });
    this.setState({ files: filesFiltered });
  };

  removeRejectFile = (idx) => {
    let { rejectFiles } = this.state;
    const filesFiltered = rejectFiles.filter(function (value, index, arr) {
      return index !== idx;
    });
    this.setState({ rejectFiles: filesFiltered });
  };

  render() {
    const { files, rejectFiles } = this.state;
    const thumbs = files.map((file, idx) => (
      <div className="thumb" key={file.name}>
        <div className="thumbInner">
          <Alert style={{ marginBottom: "0px" }}>
            {file.name}&nbsp;
            <li
              style={{ cursor: "pointer" }}
              onClick={(event) => this.removeImage(idx)}
              className="fa fa-close"
            />
          </Alert>
        </div>
      </div>
    ));
    const thumbsRejected = rejectFiles.map((file, idx) => (
      <Alert key={idx} bsStyle='danger'>{file.name}</Alert>
    ));
    const { isIntervention } = this.state;
    const textDZ = isIntervention ?
      "Déposer un seul fichier PDF ou cliquer pour choisir le fichier (taille max par fichier 8 MO-- Taille max totale: 50 MO) " :
      "Déposer des fichiers ou cliquer pour choisir des fichiers (taille max par fichier 8 MO-- Taille max totale: 50 MO) ";

    return (
      <React.Fragment>
        <DropZone onDrop={this.onDrop}>
        {({ getRootProps, getInputProps }) => (
          <section className="container-dz">
            <div {...getRootProps({ className: "dropzone" })}>
              <input {...getInputProps()} />
              <p>{textDZ}</p>
            </div>
            {files.length > 0 ? (
              <aside className="thumbsContainer">{thumbs}</aside>
            ) : null}
          </section>
        )}
        </DropZone>
        {rejectFiles.length > 0 ? (
          <Modal show={this.state.showError} onHide={this.handleClose}>
            <Modal.Header closeButton>
              <Modal.Title>Fichiers rejetés</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {thumbsRejected}
            </Modal.Body>
          </Modal>
        ) : null}
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Request/UploadZone.js